import { render, staticRenderFns } from "./ed-list.vue?vue&type=template&id=49e959e3&scoped=true&"
import script from "./ed-list.ts?vue&type=script&lang=js&"
export * from "./ed-list.ts?vue&type=script&lang=js&"
import style0 from "./ed-list.scss?vue&type=style&index=0&id=49e959e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e959e3",
  null
  
)

export default component.exports